import { render, staticRenderFns } from "./m_gallery.vue?vue&type=template&id=4af1dfb4&scoped=true&"
import script from "./m_gallery.vue?vue&type=script&lang=js&"
export * from "./m_gallery.vue?vue&type=script&lang=js&"
import style0 from "./m_gallery.vue?vue&type=style&index=0&id=4af1dfb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af1dfb4",
  null
  
)

export default component.exports